import * as React from 'react';
/** @hidden */
export var ZIndexContext = React.createContext(0);
/** @hidden */
export var useZIndexContext = function () { return React.useContext(ZIndexContext); };
ZIndexContext.displayName = 'KendoReactZIndexContext';
